
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import { Button } from "@mui/material";

const CustomOptions = ({
    type,
    width = "190px",
    selected,
    onClick,
    disabled,
}) => {
    return (
        <Button
            size="small"
            variant="contained"
            endIcon={
                <CheckCircleIcon
                    style={{
                        color: disabled ? "#d7d7d7" : selected ? "#00ba00" : "#d7d7d7",
                    }}
                />
            }
            style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                fontWeight: 400,
                fontSize: "11px",
                border: selected ? "0.1px solid #f6ffe6" : "0.1px solid #d7d7d7",
                backgroundColor: disabled
                    ? "#f0f0f0"
                    : selected
                        ? "#f6ffe6"
                        : "#ffffff",
                color: disabled ? "#a0a0a0" : "#333333",
                borderRadius: "3px",
                textTransform: "none",
                width: width,
                padding: "2px 10px",
                whiteSpace: "nowrap",
                cursor: disabled ? "not-allowed" : "pointer",
                opacity: disabled ? 0.6 : 1,
                margin: "4px 0",
            }}
            onClick={disabled ? undefined : onClick}
            disableRipple
            disableElevation
        >
            <span title={type} style={{ flexGrow: 1, textAlign: "left", overflow: "hidden" }}>
                {type}
            </span>
        </Button>
    );
};

export default CustomOptions;